import { all, put, call, takeLatest, takeEvery } from 'redux-saga/effects'
import axios from 'portal/utils/axios-msal'

import {
  ProjectAlertClientDismissAction,
  ProjectAlertClientDismissBulkAction,
  projectAlertsLoadSuccess,
  projectAlertsLoadFailure,
  PROJECT_ALERT_CLIENT_DISMISS,
  PROJECT_ALERT_CLIENT_DISMISS_BULK,
  PROJECT_ALERTS_LOAD,
  AlertsLoadAction
} from './actions'

type GenericObject = { [key: string]: any }

function extractFilter(filter) {
  const result = {}
  if (filter == null) {
    return result
  }

  if (filter.startDate != null) {
    result['filter[CreatedAtFrom]'] = filter.startDate.toISOString()
  }
  if (filter.endDate != null) {
    result['filter[CreatedAtTo]'] = filter.endDate.toISOString()
  }

  return result
}

function* projectAlertsLoadSaga(action: AlertsLoadAction) {
  const { accountId, projectId, filter } = action

  try {
    let projectAlerts: GenericObject[] = []
    const response: { data: GenericObject[] } = yield call(() =>
      axios.get(
        `/accounts/${accountId}/projects/${projectId}/recordalerts/projectAlerts`,
        { params: { ...extractFilter(filter) } }
      )
    )

    projectAlerts = response && response.data ? [...response.data] : []

    yield put(projectAlertsLoadSuccess(accountId, projectId, projectAlerts))
  } catch (error) {
    console.error(error)
    yield put(projectAlertsLoadFailure(accountId, projectId, error))
  }
}

function* projectAlertClientDismissSaga(
  action: ProjectAlertClientDismissAction
) {
  const { accountId, projectId, projectAlertId, callbacks } = action

  try {
    yield call(() =>
      axios.put(
        `/accounts/${accountId}/projects/${projectId}/recordalerts/projectalerts/${projectAlertId}/dismiss`,
        {
          doNotRedirectOn403: true
        }
      )
    )

    yield call(() => callbacks.onSuccess?.())
  } catch (error) {
    yield call(() => callbacks.onFailure?.(error))
  }
}

function* projectAlertClientDismissBulkSaga(
  action: ProjectAlertClientDismissBulkAction
) {
  const { accountId, projectId, projectAlertIds, callbacks } = action

  try {
    yield call(() =>
      axios.put(
        `/accounts/${accountId}/projects/${projectId}/recordalerts/projectalerts/dismiss`,
        { projectAlertIds },
        {
          doNotRedirectOn403: true
        }
      )
    )

    yield call(() => callbacks.onSuccess?.())
  } catch (error) {
    yield call(() => callbacks.onFailure?.(error))
  }
}

export function* watch() {
  yield all([takeLatest(PROJECT_ALERTS_LOAD, projectAlertsLoadSaga)])
  yield takeEvery(PROJECT_ALERT_CLIENT_DISMISS, projectAlertClientDismissSaga)
  yield takeEvery(
    PROJECT_ALERT_CLIENT_DISMISS_BULK,
    projectAlertClientDismissBulkSaga
  )
}
